var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Statement"},[(_vm.swiperArr)?_c('swiper',{ref:"mySwiper",staticClass:"swiper",class:{ 'swiper-whole': _vm.isSpecial },attrs:{"options":_vm.swiperOption}},_vm._l((_vm.swiperArr),function(item,index){return _c('swiper-slide',{key:index,attrs:{"data-strId":item.strId}},[_c('router-link',{attrs:{"target":"_blank","to":{
                    path: '/detail',
                    query: {
                        strWebSiteId: _vm.$route.query.strWebSiteId,
                        strId: item.strId,
                    },
                }}},[_c('div',{staticClass:"swiper-item",style:({
                        background:
                            index == 0
                                ? 'url(' +
                                  require('../../assets/images/statementbg1.jpg') +
                                  ') no-repeat center center'
                                : index == 1
                                ? 'url(' +
                                  require('../../assets/images/statementbg2.jpg') +
                                  ') no-repeat center center'
                                : index == 2
                                ? 'url(' +
                                  require('../../assets/images/statementbg3.png') +
                                  ') no-repeat center center'
                                : index == 3
                                ? 'url(' +
                                  require('../../assets/images/statementbg4.jpg') +
                                  ') no-repeat center center'
                                : index == 4
                                ? 'url(' +
                                  require('../../assets/images/statementbg5.jpg') +
                                  ') no-repeat center center'
                                : '',
                    })},[_c('div',{staticClass:"info-wrap"},[_c('h3',{attrs:{"data-strId":item.strId}},[_vm._v(" "+_vm._s(item.strMasTitle)+" ")]),_c('div',{staticClass:"text-wrap"},[_c('p',{domProps:{"innerHTML":_vm._s(item.strText)}}),_c('i',[_vm._v("【详情】")])])]),_c('img',{attrs:{"data-strId":item.strId,"data-src":item.strPicPath,"src":item.strPicPath,"alt":""}})])])],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }